import styled from 'styled-components'

export const ChipList = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  padding: 1px 2px 1px ${({ theme }) => theme.spacing.sm}rem;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.lg}rem;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.metalGray};
`

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;

  svg {
    width: 9px;
    height: 9px;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.neutralGray};
  }
`

export const ChipInput = styled.input`
  flex: 1;
  min-width: 120px;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  border: none;
  outline: none;
  background: transparent;
`
